<template>
    <div>
        <JetLabel value="Destinataires"/>
        <div class="grid grid-cols-4 gap-4 p-2 border">
            <label v-for="role in roles" :key="role.value" class="flex items-center space-x-2">
                <input type="checkbox" class="form-checkbox text-greendack-700" :value="role.value" v-model="selected" />
                <span class="capitalize">{{ role.label }}</span>
            </label>
        </div>
    </div>
</template>


<script>
    import JetLabel from '@/Jetstream/Label'

    export default {
        components:{
            JetLabel
        },

        props:{
            modelValue:Array,
            roles:Array
        },

        computed:{
            selected:{
                get(){
                    return this.modelValue
                },

                set(value){
                    this.$emit(
                        'update:modelValue',
                        value
                    )
                }
            }
        }
    }
</script>